module.exports = __webpack_public_path__ + "img/on.5e146b44.svg";